const ht = {
  home: 'Akèy',
  marketplace: 'Mache',
  products: 'Pwodui',
  login: 'Konekte',
  logout: 'Dekonekte',
  register: 'Enskri',
  myAccount: 'Kont mwen',
  adminPanel: 'Admin',
  cart: 'Panyè',
  heroTitle: 'Rechaj jwèt & kat kado pou mond lan',
  heroSubtitle: 'Livrezon rapid · Kat & crypto mondyal · NatCash & MonCash ann Ayiti',
  heroSubtitleGlobal: 'Livrezon rapid · Peye ak kat (USD) oswa crypto toupatou',
  globalHeroBadge: 'Boutik dijital · 50+ peyi',
  globalPaymentsRibbon: '🌍 Kat & crypto mondyal · 🇭🇹 NatCash & MonCash ann Ayiti',
  globalPaymentsRibbonGlobal: '🌍 Kat & crypto mondyal · Peman an sekirite',
  trendingGamesTitle: 'Tandans mondyal',
  howItWorksLink: 'Kijan li mache',
  heroSlide2Title: 'Livrezon dijital imedya',
  heroSlide2Subtitle: 'Resevwa kòd ou yo touswit apre peman',
  heroSlide3Title: 'Pi bon pri garanti',
  heroSlide3Subtitle: 'Pri ki pi konpetitif pou tout pwodui dijital',
  exploreProducts: 'Gade pwodui yo',
  shopNow: 'Achte kounye a',
  downloadApp: 'Telechaje aplikasyon an',
  installApp: 'Enstale aplikasyon an',
  installAppHint: 'Pou enstale: louvri meni Chrome (⋮), epi peze « Enstale aplikasyon an » oswa « Ajoute sou ekran akèy ».',
  appInstalledToast: 'KayiCom enstale. Louvri li sou ekran akèy ou!',
  apkDownloadStarted: 'APK la ap telechaje. Louvri fichye a epi enstale li.',
  appUpdateTitle: 'Mizajou disponib',
  appUpdateMessage: 'Yon nouvo vèsyon KayiCom pare. Mete ajou kounye a pou dènye koriksyon ak fonksyonalite yo.',
  appUpdateLater: 'Pita',
  appUpdateNow: 'Mete ajou kounye a',
  appUpdateInstalling: 'Ap telechaje mizajou a…',
  appUpdatePermission: 'Pèmèt KayiCom enstale mizajou yo, epi eseye ankò.',
  appUpdateFailed: 'Mizajou a echwe. Eseye ankò.',
  appUpdateManualHint: 'Louvri paj sa a nan Chrome, peze Telechaje, epi enstale nouvo APK KayiCom la yon fwa. Pwochen mizajou yo ap enstale depi nan aplikasyon an.',
  appUpdateVersionLine: 'Ou gen v{local} → v{remote}',
  appUpdatePlayProtectHint: 'Si Play Protect bloke enstalasyon an, chwazi Enstale kanmenm.',
  getStarted: 'Kòmanse',
  instantDelivery: 'Livrezon rapid',
  instantDeliveryDesc: 'Kòd yo delivre an kèk segond',
  securePayment: 'Peman an sekirite',
  securePaymentDesc: 'Tranzaksyon pwoteje',
  support247: 'Sipò 24/7',
  support247Desc: 'Èd lè ou bezwen li',
  competitivePrice: 'Pri konpetitif',
  competitivePriceDesc: 'Pi bon valè garanti',
  bestsellerLabel: 'Pi vann',
  bestSellingProducts: 'Pwodui ki pi vann',
  categoryDeals: 'Òf espesyal',
  viewAll: 'Gade tout',
  latestBlogPosts: 'Dènye atik yo',
  visitBlog: 'Ale sou blog la',
  salesCount: 'vann',
  noProductsAvailable: 'Pa gen pwodui disponib',
  totalProducts: 'Pwodui',
  totalSales: 'Vant',
  totalCategories: 'Kategori',
  blog: 'Blog',
  blogSubtitle: 'Gid, anons ak konsèy sou pwodui dijital ak streaming',
  blogFeatured: 'An vedèt',
  readMore: 'Li plis',
  readArticle: 'Li atik la',
  backToBlog: 'Retounen nan blog',
  loadingPosts: 'Ap chaje atik yo...',
  loadingPost: 'Ap chaje atik la...',
  noBlogPosts: 'Poko gen atik pibliye.',
  postNotFound: 'Atik sa a pa disponib.',
  minRead: 'min lekti',
  relatedArticles: 'Atik ki gen rapò',
  allArticles: 'Tout atik yo',
  allProducts: 'Tout pwodui yo',
  productsSubtitle: 'Jwenn pi bon òf dijital yo imedyatman.',
  noProductsInCategory: 'Pa gen pwodui nan kategori sa a',
  noProductsYet: 'Pa gen pwodui pou kounye a.',
  showingResultsFor: 'Rezilta pou',
  itemsCount: 'atik',
  allCategories: 'Tout',
  topupHeroTitle: 'Rechaj jwèt',
  topupHeroSubtitle: 'Rechaje Free Fire LATAM ak Delta Force — delivre imedyatman sou kont ou.',
  topupPlayerVerify: 'Verifikasyon Player ID',
  topupPlayerVerifyDesc: 'Nou verifye ID ou anvan livrezon',
  topupAutoDelivery: 'Livrezon otomatik',
  topupAutoDeliveryDesc: 'Kredi delivre an kèk minit',
  browseByGame: 'Chèche pa jwèt',
  allGames: 'Tout jwèt yo',
  otherGames: 'Lòt jwèt',
  howItWorks: 'Kijan li mache',
  topupStep1: 'Chwazi jwèt ak pakè ou',
  topupStep2: 'Chwazi yon pakè epi antre Player ID ou',
  topupStep3: 'Peye an sekirite epi resevwa imedyatman',
  topupIdDialogDesc: 'Antre ID ou nan jwèt la pou kontinye. Sa obligatwa pou livrezon.',
  topupSelectPackage: 'Chwazi yon pakè',
  topupPackages: 'pakè',
  topupBuy: 'Achte kounye a',
  topupOfficialBadge: 'Top-up ofisyèl',
  topupProductSubtitle: 'Chwazi yon pakè epi rechaje kont ou!',
  topupVerifyPlayerId: 'Verifye Player ID',
  topupSelected: 'Pakè chwazi',
  topupSearchGames: 'Chèche yon jwèt...',
  topupPopularGames: 'Popilè',
  topupSelectGame: 'Chwazi jwèt ou',
  topupInstantBadge: 'Imedyat',
  topupPopularSection: 'Popilè',
  topupDirectSection: 'Rechaj dirèk',
  topupBestSellers: 'Pi vann yo pou ou',
  topupBestSellerBadge: 'Pi vann',
  topupBrowseAll: 'Tout pakè yo',
  topupStepEnterId: 'Antre Player ID ou',
  topupSelectTopUp: 'Chwazi rechaj la',
  topupContinueCheckout: 'Kontinye pou peye',
  topupViewAll: 'Gade tout',
  topupTrending: 'Tandans',
  topupPacksDiamonds: 'Diamonds',
  topupPacksCoins: 'Pyès',
  topupPacksUc: 'UC',
  topupPacksRobux: 'Robux',
  topupPacksCp: 'CP',
  topupPacksGold: 'Gold',
  topupPacksSpecials: 'Òf espesyal',
  topupPacksBonus: 'Bonus',
  accountType: 'Kalite kont',
  backToGames: 'Retounen nan jwèt yo',
  playerName: 'Non jwè a',
  fromPrice: 'Apati de',
  noTopupPackages: 'Pa gen pakè pou jwèt sa a ankò.',
  viewGamePage: 'Louvri paj jwèt la',
  subscriptionHeroTitle: 'Abònman premium',
  subscriptionHeroSubtitle: 'Netflix, Spotify, Disney+, YouTube Premium ak plis — aktive rapidman ak pri ki pa gen konpetisyon.',
  subscriptionInstantDesc: 'Detay aksè delivre an kèk minit',
  subscriptionRenewLabel: 'Plan fleksib',
  subscriptionRenewDesc: 'Chwazi dire ki bon pou ou',
  subscriptionStep1: 'Chwazi abònman ou ak dire a',
  subscriptionStep2: 'Peye an sekirite ak metòd ou pi renmen an',
  subscriptionStep3: 'Resevwa detay aksè ou epi jwi',
  editPlayerId: 'Chanje Player ID',
  saveAndContinue: 'Anrejistre epi kontinye',
  playerIdRequired: 'Player ID obligatwa',
  idSaved: 'ID anrejistre',
  verifyingId: 'Ap verifye...',
  idVerified: 'ID verifye',
  floatingAnnouncementLabel: 'Anons',
  floatingAnnouncementDismiss: 'Konprann',
  natcashPaymentTitle: 'Peman NatCash',
  natcashAccountName: 'Non kont lan',
  natcashPhone: 'Nimewo NatCash',
  natcashAmount: 'Montan pou voye',
  natcashReference: 'Kòd referans (mete nan Kontni)',
  natcashWaitingPayment: 'Ap tann peman',
  natcashHowToPay: 'Kijan pou peye ak NatCash:',
  natcashStep1: 'Konpoze *202# sou telefòn ou',
  natcashStep2: 'Chwazi Transfè',
  natcashStep3: 'Antre montan egzak ki parèt anwo a',
  natcashStep4: 'Nan chan Kontni a, antre kòd referans ki parèt anwo a',
  natcashStep5: 'Antre PIN NatCash ou',
  natcashStep6: 'Peze Voye pou fini peman an',
  natcashPhoneWarning: 'Nimewo telefòn ou voye soti a dwe menm ak sa ou te itilize lè ou te pase kòmand la.',
  natcashVerifyNow: 'VERIFYE KOUNYE A',
  natcashSmsCountdown: 'Ap tann SMS',
  natcashAutoCheck: 'Sistèm nan verifye otomatikman chak 10 segonn',
  natcashAutoPayHint: 'Voye montan egzak la epi mete kòd referans la nan Kontni — konfirmasyon otomatik.',
  natcashVerifying: 'Ap verifye...',
  natcashCopy: 'KOPIE',
  natcashCopied: 'Kopye!',
  natcashAutoPayment: 'Peman otomatik — NatCash/Natcom',
  natcashTotalHtg: 'Total NatCash (HTG)',
  paymentConfirmed: 'Peman konfime!',
  paymentConfirmedPreparingDelivery: 'Peman konfime. N ap prepare livrezon ou. Relouvri paj sa a pou wè l.',
  autoDeliveryPendingHint: 'Nou resevwa kòmand ou a e n ap trete l. Tanpri tann pandan n ap fini livrezon an.',
  transcodeLabel: 'Transcode',
  transcodePayHint: 'Peye montan egzak ki parèt anwo a, epi kole Transcode ki nan SMS la anba a.',
  moncashPayHint: 'Peye montan egzak la ak nimewo MonCash ou a (509 + 8 chif) — konfirmasyon otomatik ak nimewo a ak montan an, pa bezwen Transcode.',
  moncashOrderCreated: 'Kòmand kreye! Peye montan egzak la ak nimewo MonCash ou a — konfirmasyon otomatik ak nimewo a ak montan an.',
  moncashTopupCreated: 'Rechaj kreye! Peye montan egzak la ak nimewo MonCash ou a — konfirmasyon otomatik ak nimewo a ak montan an.',
  transcodeSmsNote: 'Apre ou fin peye, NatCash ap voye yon SMS konfirmasyon sou telefòn ou. Transcode a parèt nan mesaj la — kopye li epi kole l nan chan ki anba a.',
  transcodePlaceholder: 'egz. 26082105770513',
  transcodeEnterHint: 'Antre Transcode ki nan SMS NatCash la',
  transcodeVerify: 'Verifye montan + Transcode',
  transcodeVerifying: 'Ap verifye montan + Transcode…',
  transcodeApproved: 'Peman konfime.',
  moncashAutoPayment: 'Peman MonCash otomatik (HTG)',
  moncashMinPurchase: 'Achte minimòm',
  moncashNeedMore: 'ou bezwen',
  moncashNeedMoreSuffix: 'ankò',
  moncashFee: 'Frè MonCash',
  natcashFee: 'Frè NatCash',
  htgPaymentFee: 'Frè peman',
  moncashFeeOnOrder: 'sou kòmand sa a',
  moncashMinimum: 'Minimòm MonCash',
  moncashTotalWithFee: 'Total ak frè',
  moncashAmountToPay: 'Montan pou peye sou MonCash',
  moncashMerchantPhone: 'Nimewo MonCash',
  moncashPayerPhone: 'Nimewo ou dwe voye a',
  moncashToPay: 'Montan pou peye',
  moncashPayWith: 'Peye ak MonCash',
  moncashAutoConfirm: 'Konfirmasyon otomatik apre peman MonCash',
  moncashOpenPayment: 'Louvri peman MonCash',
  moncashIPaidVerify: 'Mwen peye — Verifye',
  moncashChecking: 'Ap verifye…',
  moncashLinkMissing: 'Lyen peman MonCash manke',
  moncashVerifyFailed: 'Pa t kapab verifye peman MonCash',
  moncashPaymentConfirmed: 'Peman MonCash konfime!',
  moncashPaymentPending: 'Peman toujou annatant',
  moncashRedirecting: 'Ap redirije nan MonCash...',
  moncashContinueOnTracking: 'Kòmand kreye! Kontinye peman MonCash sou paj swivi a.',
  moncashMinPurchaseIs: 'Achte minimòm MonCash se',
  moncashMinShort: 'Min MonCash',
  moncashOrderTotal: 'Total kòmand',
  plopplopUssdOption: 'Peye ak envitasyon USSD sou telefòn MonCash ou — pa gen paj redireksyon',
  plopplopUssdHint: 'API a voye envitasyon USSD e li bay nimewo TRANSACTION lan. Aksepte sou telefòn nan; nou verifye id API a otomatikman.',
  plopplopUssdNoPromptHint: 'Yo pa voye envitasyon USSD si kont e-money MonCash sa a pa gen ase kob, oswa si nimewo a se NatCash.',
  plopplopUssdResend: 'Voye envitasyon USSD ankò',
  plopplopUssdResent: 'Nou mande yon nouvo envitasyon USSD MonCash. Aksepte l sou menm telefòn nan.',
  plopplopUssdResendFailed: 'Nou pa t kapab voye envitasyon USSD a ankò',
  ussdPayPageTitle: 'Peman MonCash USSD',
  ussdPayPageHint: 'API a voye envitasyon USSD e li bay nimewo TRANSACTION lan. Ou aksepte sou telefòn nan; sistèm nan verifye id API a otomatikman.',
  ussdPayButton: 'Peye',
  ussdIPaidButton: 'Mwen peye',
  ussdTxnFromSms: 'Nimewo tranzaksyon MonCash nan SMS la',
  ussdTxnFromSmsHint: 'Si Mwen peye pa jwenn li, antre nimewo tranzaksyon an nan SMS MonCash la, epi klike Mwen peye ankò.',
  ussdPaySent: 'Envitasyon USSD voye. Aksepte l sou telefòn MonCash ou.',
  ussdPayWaiting: 'Ap verifye TRANSACTION API a… pa bezwen antre okenn nimewo.',
  plopplopPhoneLabel: 'Nimewo telefòn MonCash',
  plopplopPhoneRequired: 'Antre yon nimewo MonCash valab (39308318)',
  plopplopRedirectHint: 'Fini peman an sou paj sekirize a. Ekran sa a ap mete ajou otomatikman, epi kòmand la ap livrez.',
  plopplopCardTitle: 'Kat debi / kredi',
  plopplopCardDesc: 'Peye ak kat an sekirite (USD). Nou voye enfòmasyon ou yo otomatikman.',
  plopplopCardHint: 'Fini peman kat la. Yo prelve montan an an USD. Ekran sa a ap mete ajou otomatikman, epi kòmand la ap livrez.',
  plopplopCardRedirecting: 'Ap redirije nan peman kat (USD)…',
  plopplopOpenCardPayment: 'Kontinye peman kat',
  plopplopOpenHostedPayment: 'Kontinye peman',
  plopplopPaymentExpired: 'Peman sa a ekspire apre 10 minit. Fè yon nouvo kòmand pou peye.',
  plopplopCardAmountHtg: 'Total kat (USD)',
  plopplopCardFee: 'Frè kat',
  plopplopCardPayUsd: 'Yo prelve an USD',
  plopplopCardAutoConfirm: 'Peman an konfime otomatikman apre ou peye.',
  redirectingCardPayment: 'Ap redirije nan paj peman kat la…',
  stripeCardPayTitle: 'Peman kat an sekirite',
  stripeCardWalletHint: 'Google Pay ak Apple Pay parèt sou paj checkout sekirize a lè aparèy ou sipòte yo.',
  stripeCardPaySubtitle: 'Antre enfòmasyon kat ou a pou fini kòmand la.',
  stripeCardEmbeddedHint: 'Peye an sekirite ak kat debi oswa kredi (USD).',
  continueToCard: 'Kontinye nan peman kat',
  payWithCard: 'Peye ak kat',
  backToOrder: 'Retounen nan kòmand la',
  stripeAcceptedCards: 'Nou aksepte',
  stripe3dsHint: 'Verifikasyon 3D Secure si sa nesesè',
  stripeStatementPrefix: 'Sou relevé bankè',
  poweredBy: 'Powered by',
  cardNumber: 'Nimewo kat',
  cardExpiry: 'Dat ekspirasyon',
  cardCvc: 'CVV',
  saveCardForNextPayment: 'Sove kat sa a pou pwochen peman',
  stripeCardFormHint: 'Antre nimewo kat, dat ekspirasyon ak CVV ou.',
  stripeSecuredBy: 'Peye an sekirite via Stripe',
  stripeHostedPayHint: 'Antre nimewo kat, dat ekspirasyon ak CVV ou anba a.',
  stripeWalletHint: 'Peye ak Apple Pay, Google Pay, oswa kat',
  stripeApplePayTitle: 'Apple Pay',
  stripeGooglePayTitle: 'Google Pay',
  stripeApplePayHint: 'Itilize Apple Pay pou fini kòmand ou an sekirite.',
  stripeGooglePayHint: 'Itilize Google Pay pou fini kòmand ou an sekirite.',
  stripeApplePayCheckoutHint: 'Peye ak Apple Pay sou aparèy ou.',
  stripeGooglePayCheckoutHint: 'Peye ak Google Pay sou aparèy ou.',
  stripeApplePayUnavailable: 'Apple Pay pa disponib kounye a. Verifye ou gen kat nan Wallet, ouvri sit la nan Safari, epi eseye ankò. Sinon itilize kat debi/kredi.',
  stripeGooglePayUnavailable: 'Google Pay pa disponib sou aparèy oswa navigatè sa a. Eseye Chrome sou Android, oswa itilize kat debi/kredi.',
  redirectingApplePay: 'Ap redirije nan Apple Pay…',
  redirectingGooglePay: 'Ap redirije nan Google Pay…',
  continueToApplePay: 'Kontinye nan Apple Pay',
  continueToGooglePay: 'Kontinye nan Google Pay',
  stripeGooglePayUnavailableIos: 'Google Pay pa mache nan navigatè sou iPhone. Itilize Apple Pay oswa kat debi/kredi.',
  stripeApplePayUnavailableAndroid: 'Apple Pay pa disponib sou Android. Itilize Google Pay oswa kat debi/kredi.',
  stripeApplePayUnavailableSafari: 'Sou iPhone, ouvri kayicom.com nan Safari (pa Chrome) pou itilize Apple Pay.',
  stripeWalletUnavailable: 'Wallet sa a pa disponib sou aparèy oswa navigatè sa a.',
  stripeWalletChooseAnotherMethod: 'Chwazi yon lòt metòd peman',
  stripeWalletLoadError: 'Bouton wallet la pa t chaje. Eseye ankò oswa chwazi yon lòt metòd peman.',
  retry: 'Eseye ankò',
  stripeGooglePayHostedFallback: 'Louvri Google Pay checkout',
  stripeApplePayHostedFallback: 'Louvri Apple Pay checkout',
  stripeGooglePayChromeHint: 'Sou Android, itilize Chrome ak Google Pay konfigire nan kont Google ou.',
  stripeApplePaySafariHint: 'Sou iPhone, itilize Safari ak Apple Pay aktive nan Settings.',
  stripeWalletHostedFallbackLink: 'Bouton pa parèt? Louvri checkout wallet sekirize',
  stripeGooglePayHostedHint: 'Peze bouton an pou peye ak Google Pay sou paj Stripe sekirize a.',
  stripeApplePayHostedHint: 'Peze bouton an pou peye ak Apple Pay sou paj Stripe sekirize a.',
  payWithGooglePay: 'Peye ak Google Pay',
  payWithApplePay: 'Peye ak Apple Pay',
  paymentDescription: 'Deskripsyon peman',
  playerFound: 'Jwè jwenn',
  categoryTitle: 'Kategori pwodui',
  giftCards: 'Kat kado',
  gameTopup: 'Rechaj jwèt',
  subscriptions: 'Abònman',
  services: 'Sèvis',
  crypto: 'Kripto',
  whatWeOffer: 'Sa nou ofri',
  offerSubtitle: 'Chwazi pami plizyè kategori pwodui dijital ak livrezon imedya',
  internationalGiftCards: 'Kat kado entènasyonal',
  giftCardsDesc: 'Amazon, Google Play, iTunes, Steam ak plis',
  automaticGameTopup: 'Rechaj jwèt otomatik',
  gameTopupDesc: 'Free Fire LATAM ak Delta Force — livrezon imedya',
  premiumSubscriptions: 'Abònman premium',
  subscriptionsDesc: 'Netflix, Spotify, Disney+ ak lòt sèvis',
  digitalServices: 'Sèvis dijital',
  servicesDesc: 'Kreye kont Stripe, verifye PayPal, TextNow',
  featuredProducts: 'Pwodui an vedèt',
  buyNow: 'Achte kounye a',
  addToCart: 'Mete nan panyè',
  viewDetails: 'Gade detay',
  available: 'Disponib',
  outOfStock: 'Pa gen stock',
  readyToStart: 'Pare pou kòmanse?',
  email: 'Imèl',
  emailPlaceholder: 'imel@ou.com',
  whatsappNumber: 'Nimewo WhatsApp',
  whatsappPlaceholder: '50912345678',
  password: 'Modpas',
  fullName: 'Non konplè',
  confirmPassword: 'Konfime modpas',
  dontHaveAccount: 'Ou pa gen kont?',
  alreadyHaveAccount: 'Ou gen deja yon kont?',
  createAccount: 'Kreye kont',
  gmailYahooOnly: 'Sèl imèl Gmail oswa Yahoo ki ka kreye yon kont.',
  verifyEmailSent: 'Kont lan kreye. Tcheke imèl ou epi verifye l pou w kontinye.',
  verifyEmailToContinue: 'Verifye imèl ou pou w kontinye. Nou voye yon lyen ba ou.',
  verifyEmailTitle: 'Verifye imèl ou',
  verifyEmailMissingToken: 'Ouvri lyen verifikasyon an nan imèl ou, oswa voye l ankò.',
  verifyEmailBanner: 'Verifye imèl ou pou w ka pase premye kòmand ou.',
  resendVerification: 'Voye imèl verifikasyon an ankò',
  rememberMe: 'Sonje mwen',
  showPassword: 'Montre modpas',
  hidePassword: 'Kache modpas',
  forgotPassword: 'Ou bliye modpas?',
  orContinueWith: 'oswa kontinye ak',
  continueWithGoogle: 'Kontinye ak Google',
  continueWithTelegram: 'Kontinye ak Telegram',
  socialLoginStateInvalid: 'Sesyon sosyal la ekspire. Eseye ankò.',
  securityCheck: 'Verifikasyon sekirite',
  securityCheckHint: 'Rezoud adisyon sa a pou montre ou se moun.',
  enterResult: 'Antre rezilta a',
  solveSecurityCheck: 'Tanpri rezoud verifikasyon sekirite a',
  refresh: 'Rafrechi',
  resetPassword: 'Reyinisyalize modpas',
  sendResetLink: 'Voye lyen reyinisyalizasyon',
  backToLogin: 'Retounen nan koneksyon',
  newPassword: 'Nouvo modpas',
  confirmNewPassword: 'Konfime nouvo modpas',
  passwordsDoNotMatch: 'Modpas yo pa menm',
  resetLinkSent: 'Si imèl la egziste, yon lyen reyinisyalizasyon voye.',
  resetSuccess: 'Modpas reyinisyalize. Tanpri konekte.',
  tokenMissing: 'Jeton reyinisyalizasyon manke oswa pa valab.',
  yourCart: 'Panyè ou',
  emptyCart: 'Panyè ou vid',
  continueShopping: 'Kontinye achte',
  orderSummary: 'Rezime kòmand',
  subtotal: 'Sou-total',
  total: 'Total',
  items: 'atik',
  checkout: 'Peye',
  placeOrder: 'Pase kòmand',
  paymentMethod: 'Metòd peman',
  cryptocurrency: 'Kriptomonna (Otomatik)',
  manualPayment: 'Peman manyèl',
  cryptoDesc: 'Bitcoin, Ethereum, ak plis',
  manualDesc: 'Transfè labank, lòt metòd (prèv obligatwa)',
  orderTracking: 'Swiv kòmand',
  orderNumber: 'Kòmand',
  orderStatus: 'Estati kòmand',
  paymentStatus: 'Estati peman',
  orderItems: 'Atik kòmand',
  submitProof: 'Soumèt prèv peman',
  transactionId: 'ID tranzaksyon',
  proofUrl: 'URL prèv',
  uploadProof: 'Telechaje prèv',
  dashboard: 'Tablo bò',
  myOrders: 'Kòmand mwen yo',
  totalOrders: 'Total kòmand',
  pendingOrders: 'Kòmand annatant',
  completedOrders: 'Kòmand fini',
  noOrders: 'Ou pa gen okenn kòmand ankò',
  manageProducts: 'Jere pwodui yo',
  manageOrders: 'Jere kòmand yo',
  siteSettings: 'Paramèt sit la',
  addProduct: 'Ajoute pwodui',
  editProduct: 'Modifye pwodui',
  deleteProduct: 'Efase pwodui',
  productName: 'Non pwodui',
  description: 'Deskripsyon',
  category: 'Kategori',
  price: 'Pri',
  currency: 'Deviz',
  imageUrl: 'URL imaj',
  stockAvailable: 'Stock disponib',
  deliveryType: 'Kalite livrezon',
  automatic: 'Otomatik',
  manual: 'Manyèl',
  save: 'Anrejistre',
  cancel: 'Anile',
  general: 'Jeneral',
  apiKeys: 'Kle API',
  appearance: 'Aparans',
  siteName: 'Non sit la',
  supportEmail: 'Imèl sipò',
  logoUrl: 'URL logo',
  primaryColor: 'Koulè prensipal',
  secondaryColor: 'Koulè segondè',
  saveSettings: 'Anrejistre paramèt yo',
  aboutUs: 'Sou nou',
  contact: 'Kontak',
  footerCompany: 'Konpayi',
  footerCategories: 'Kategori',
  footerSocial: 'Rezo sosyal',
  footerBlogs: 'Blog',
  footerTagline: 'Kat kado, rechaj jwèt, abònman ak sèvis dijital ak livrezon rapid.',
  footerSocialComingSoon: 'N ap sou rezo sosyal yo byento.',
  quickLinks: 'Lyen rapid',
  support: 'Sipò',
  refundPolicy: 'Politik ranbousman',
  privacyPolicy: 'Politik konfidansyalite',
  amlPolicy: 'Politik AML',
  legalPagesNav: 'Legal & politik',
  legalOnThisPage: 'Sou paj sa a',
  allRightsReserved: 'Tout dwa rezève',
  trustpilotViewReviews: 'Gade revi nou sou Trustpilot',
  loading: 'Chajman...',
  processing: 'Ap trete...',
  success: 'Siksè!',
  error: 'Erè',
  loginSuccess: 'Koneksyon reyisi!',
  logoutSuccess: 'Dekoneksyon reyisi!',
  productAdded: 'Pwodui ajoute nan panyè',
  productRemoved: 'Pwodui retire nan panyè',
  orderPlaced: 'Kòmand pase avèk siksè!',
  proofSubmitted: 'Prèv peman soumèt avèk siksè!',
  myWallet: 'Bous mwen',
  withdrawBalance: 'Balans retrè',
  pendingBalance: 'Balans annatant',
  consumableBalance: 'Balans konsomab',
  withdraw: 'Retire',
  recharge: 'Rechaje',
  topUpWallet: 'Rechaje bous',
  amountUsd: 'Montan (USD)',
  enterAmount: 'Antre montan',
  toPayHtg: 'Pou peye: {amount} HTG',
  confirm: 'Konfime',
  creditsBalance: 'Balans kredi',
  creditsRateHint: '1000 kredi = $1.00',
  creditsPlaceholder: 'Kredi',
  convert: 'Konvèti',
  transactionsTab: 'Tranzaksyon',
  topupsTab: 'Rechaj',
  noTransactionsYet: 'Pa gen tranzaksyon ankò',
  noTopupsYet: 'Pa gen rechaj ankò',
  topupDetails: 'Detay rechaj',
  close: 'Fèmen',
  selectTopupDetails: 'Chwazi yon rechaj pou wè detay yo.',
  walletCredited: 'Bous la kredite avèk siksè.',
  paidCrediting: 'Peye — ap kredite bous la...',
  openPlisioInvoice: 'Louvri fakti Plisio',
  cryptoInvoiceAuto: 'Fakti crypto a ta dwe louvri otomatikman.',
  iPaidVerifyCrypto: 'Mwen peye — Verifye crypto',
  cryptoAutoCheck: 'Nou verifye otomatikman chak 10 segonn apre peman.',
  verifying: 'Ap verifye...',
  errorLoadingWallet: 'Erè pandan chajman bous la',
  enterValidAmount: 'Antre yon montan valab',
  enterCreditsMultiple: 'Antre kredi (miltip 1000)',
  creditsMustBeMultiple: 'Kredi yo dwe yon miltip 1000',
  convertedCreditsSuccess: 'Konvèti {credits} kredi → {amount}',
  errorConvertingCredits: 'Erè pandan konvèsyon kredi',
  redirectingCryptoPayment: 'Ap redirije nan peman crypto...',
  cryptoNotAvailable: 'Peman crypto pa disponib',
  topupCreatedTranscode: 'Rechaj kreye — peye epi antre Transcode ou anba a.',
  topupCreatedAuto: 'Rechaj kreye — peman ap verifye otomatikman',
  errorCreatingTopup: 'Erè pandan kreyasyon rechaj',
  paymentConfirmedWallet: 'Peman konfime! Bous la kredite.',
  cryptoNotConfirmedYet: 'Peman crypto poko konfime',
  plisioVerifyFailed: 'Verifikasyon Plisio echwe',
  cryptoAuto: 'Crypto (Otomatik)',
  natcashAuto: 'NatCash (Oto)',
  moncashAuto: 'MonCash (Oto)',
  binancePayAuto: 'Binance Pay (Oto)',
  balance: 'Balans',
  points: 'Pwen',
  sellerCenter: 'Sant vandè',
  sellerApplication: 'Aplikasyon vandè',
  becomeSeller: 'Vin vandè',
  purchasedOrders: 'Kòmand achte',
  mySubscriptions: 'Abònman mwen',
  coupon: 'Koupon',
  referral: 'Referans',
  messages: 'Mesaj',
  disputes: 'Litij',
  helpCenter: 'Sant èd',
  notification: 'Notifikasyon',
  termsConditions: 'Kondisyon',
  termsContactHeading: 'Kontak',
  termsContactText: 'Kesyon sou kondisyon yo? Ekri nou nan',
  customerIdCopied: 'ID kliyan kopye',
  couldNotCopy: 'Pa t kapab kopye',
  customer: 'Kliyan',
  pendingBadge: 'Annatant',
  activeBadge: 'aktif',
  newBadge: 'nouvo',
  filterAll: 'Tout',
  filterPending: 'Annatant',
  filterProcessing: 'Ap trete',
  filterCompleted: 'Fini',
  filterCancelled: 'Anile',
  orderHash: 'Kòmand #{id}',
  itemsLabel: 'atik',
  startShopping: 'Kòmanse achte',
  noOrdersYet: 'Pa gen kòmand ankò',
  oneYear: '1 Ane',
  month: 'Mwa',
  months: 'Mwa',
  paymentMethodCryptocurrency: 'Kriptomonna',
  paymentMethodBinancePay: 'Binance Pay (Oto)',
  paymentMethodBinanceManual: 'Binance Pay (Manyèl)',
  mustLoginToContinue: 'Ou dwe konekte pou kontinye',
  walletBalanceTitle: 'Balans bous',
  clickLoadWalletBalance: 'Klike pou chaje balans bous la',
  balanceAmount: 'Balans: {amount}',
  insufficientWalletBalance: 'Balans pa ase. Rechaje bous ou anvan.',
  topUpWalletBtn: 'Rechaje bous',
  cryptoCheckoutDesc: 'Bitcoin, Ethereum, USDT - Livrezon rapid',
  binancePay: 'Binance Pay',
  autoVerified: 'Verifye otomatikman',
  cashApp: 'Cash App',
  cashAppManualDesc: 'Verifye manyèl — soumèt prèv peman apre ou peye',
  sendTo: 'Voye bay:',
  playerIdsRequired: 'Player ID obligatwa',
  playerIdFor: '{label} pou {product}',
  enterYourLabel: 'Antre {label} ou',
  playerIdsSaved: 'Player ID yo',
  accountCredentialsRequired: 'Idantifyan kont obligatwa',
  enterField: 'Antre {field}',
  couponCode: 'Kòd koupon',
  enterCoupon: 'Antre koupon',
  apply: 'Aplike',
  applying: 'Ap aplike...',
  clear: 'Efase',
  couponApplied: 'Koupon aplike',
  couponActive: 'Koupon aktif pou kòmand sa a.',
  minOrderForCoupon: 'Kòmand minimòm pou koupon sa a: {amount}',
  discount: 'Rabè',
  secureTransaction: 'Tranzaksyon an sekirite',
  fastDelivery: 'Livrazon rapid',
  mustLoginBeforePurchase: 'Ou dwe konekte anvan ou achte',
  cartEmpty: 'Panyè ou vid',
  enterPlayerIdFirst: 'Antre yon Player ID dabò',
  playerIdVerified: 'Player ID verifye!',
  invalidPlayerId: 'Player ID pa valab',
  verificationFailed: 'Verifikasyon echwe. Eseye ankò.',
  redirectingPayment: 'Ap redirije nan peman...',
  orderCreatedTranscode: 'Kòmand kreye! Peye ak MonCash epi antre Transcode ou sou paj kòmand la.',
  orderCreatedNatcash: 'Kòmand kreye! Voye montan HTG egzak la epi mete kòd referans lan nan Kontni — konfirmasyon otomatik.',
  paidWithWallet: 'Peye ak bous avèk siksè!',
  orderCreatedSubmitProof: 'Kòmand kreye! Soumèt prèv peman ou.',
  errorCreatingOrder: 'Erè pandan kreyasyon kòmand',
  sessionExpiredLogin: 'Sesyon ou ekpire. Konekte ankò epi eseye peman an.',
  enterCouponCode: 'Antre yon kòd koupon',
  invalidCoupon: 'Koupon pa valab',
  autoLabel: 'Oto',
  checkoutPaymentsRegionHaiti: 'Rekòmande pou Ayiti: NatCash oswa MonCash (HTG).',
  checkoutPaymentsRegionGlobal: 'Peye mondyal ak kat debi/kredi (USD) oswa crypto.',
  growthShareTitle: 'Pataje & touche',
  growthShareSubtitle: 'Envite zanmi sou KayiCom',
  growthShareEarn: 'Touche $1 lè yon zanmi fini premye abònman li atravè lyen ou.',
  growthShareGuestTitle: 'Kreye yon kont pou jwenn lyen referans ou',
  growthShareGuestSubtitle: 'Pataje KayiCom ak zanmi epi touche rekonpans.',
  growthYourLink: 'Lyen referans ou',
  growthCopyLink: 'Kopye lyen',
  growthCopyLinkDone: 'Lyen kopye!',
  growthCopyLinkFail: 'Pa t kapab kopye lyen',
  growthShareWhatsApp: 'WhatsApp',
  growthShareTelegram: 'Telegram',
  growthShareWhatsAppText: 'Achte rechaj jwèt & kat kado sou KayiCom — livrezon rapid.',
  growthGoReferral: 'Tablo referans →',
  growthSharePageLabel: 'Pataje paj sa a ak zanmi',
  growthSharePageText: 'Gade {title} sou KayiCom — livrezon rapid & an sekirite.',
  growthShareNative: 'Pataje',
  growthViralSectionTitle: 'Envite zanmi, touche rekonpans',
  referralPageTitle: 'Pwogram referans',
  referralPageSubtitle: 'Pataje KayiCom ak zanmi. Touche $1 lè moun ou envite a fini premye abònman li.',
  referralPageBalance: 'Balans disponib',
  referralPageTotalReferrals: 'Zanmi ki enskri',
  referralPagePerSub: 'Pa abònman',
  referralPageCodeLabel: 'Kòd ou:',
  referralPageHowTitle: 'Kijan li mache',
  referralPageStep1Title: 'Pataje lyen ou',
  referralPageStep1Desc: 'Voye lyen pèsonèl ou sou WhatsApp, Telegram, oswa rezo sosyal.',
  referralPageStep2Title: 'Yo abònne',
  referralPageStep2Desc: 'Lè zanmi ou achte premye plan abònman sou KayiCom, ou touche $1.',
  referralPageStep3Title: 'Retire lajan ou',
  referralPageStep3Desc: 'Retire balans referans ou nenpòt lè ou rive nan minimòm la.',
  referralPageMinWithdraw: 'Retrè minimòm: $5.00 USD (kat, crypto, PayPal, oswa MonCash).',
  referralPageWithdrawReady: 'Ou ka retire balans referans ou kounye a.',
  referralPageWithdrawCta: 'Ale nan retrè',
  referralPageWithdrawNeedMore: 'Touche ${amount} anplis pou rive nan minimòm retrè $5.',
  referralPageLoadError: 'Pa t kapab chaje enfòmasyon referans.',
  referralPageRetry: 'Eseye ankò',
  howItWorksPageTitle: 'Kijan KayiCom mache',
  howItWorksPageSubtitle: 'Achte pwodui dijital nan kèk minit — depi nenpòt kote nan mond lan.',
  howItWorksStepPrefix: 'Etap',
  howItWorksStep1Title: 'Chwazi pwodui ou',
  howItWorksStep1Desc: 'Chwazi rechaj jwèt, kat kado, oswa abònman nan katalòg la.',
  howItWorksStep2Title: 'Peye an sekirite',
  howItWorksStep2Desc: 'Itilize kat (USD), crypto, oswa — ann Ayiti — NatCash / MonCash.',
  howItWorksStep2DescGlobal: 'Peye ak kat debi/kredi (USD), Binance Pay, oswa cryptocurrency.',
  howItWorksStep3Title: 'Livrezon rapid',
  howItWorksStep3Desc: 'Pwodui otomatik yo delivre nan kèk minit apre peman konfime.',
  howItWorksStep4Title: 'Sipò si ou bezwen èd',
  howItWorksStep4Desc: 'Ekip nou disponib 24/7 sou WhatsApp ak imèl.',
  howItWorksPaymentsTitle: 'Metòd peman',
  howItWorksPaymentsGlobal: 'Mondyal: kat debi/kredi (USD), Binance Pay, ak cryptocurrency.',
  howItWorksPaymentsHaiti: 'Ayiti: NatCash (referans nan Kontni, otomatik) ak MonCash (Transcode nan SMS).',
  howItWorksSupportWhatsApp: 'Pale ak sipò sou WhatsApp',
  gameLandingCta: 'Achte kounye a',
  gameLandingHow: 'Kijan li mache',
  landingFreeFireTitle: 'Free Fire LATAM — rechaj imedya',
  landingFreeFireDesc: 'Rechaje diamond Free Fire LATAM an sekirite ak livrezon otomatik sou Player ID ou.',
  landingDeltaForceTitle: 'Delta Force — rechaj imedya',
  landingDeltaForceDesc: 'Rechaje Delta Force ak livrezon otomatik sou Player ID ou.',
  landingPubgTitle: 'PUBG Mobile UC — rechaj rapid',
  landingPubgDesc: 'Achte UC PUBG Mobile sou entènèt ak peman an sekirite.',
  landingMlbbTitle: 'Diamond Mobile Legends',
  landingMlbbDesc: 'Rechaje diamond Mobile Legends nan kèk minit — checkout mondyal.',
  landingRobloxTitle: 'Roblox Robux & kat kado',
  landingRobloxDesc: 'Jwenn kredi Roblox ak kat kado ak livrezon dijital imedya.',
  landingNetflixTitle: 'Netflix & streaming',
  landingNetflixDesc: 'Abònman streaming ak kat kado — pare apre peman.',
  landingBulletInstant: 'Livrezon otomatik sou pwodui ki kalifye',
  landingBulletSecure: 'Peman an sekirite — kat, crypto, ak bous lokal',
  landingBulletSupport: 'Sipò kliyan 24/7',
};

export default ht;
